import { LogicalDeleteDTO } from '../basic/logicalDeleteDTO';

export class DeviceTypeDTO extends LogicalDeleteDTO {    //stesse cose e nomi del DTO del backend
    
    id: number;
    descrizione: string;
    device: number[];

}